<div class="fc-bulk-search-wrapper">
    <div class="fc-bulk-search-title">
        <h4>{{ 'BULK_GTIN_SEARCH.TITLE' | translate }}</h4>
    </div>

    <div class="fc-bulk-search-type-header">
        <strong>{{ 'BULK_GTIN_SEARCH.TYPE_SELECTOR.TITLE' | translate }}</strong>
    </div>

    <div class="fc-bulk-search-type-options">
        <div class="fc-bulk-search-type-options-item">
            <fcp-radiobutton
                inputId="manufacturer-search-type-article-numbers"
                name="selectedSearchType"
                [value]="searchType.ARTICLE_NUMBERS"
                [ngModel]="selectedSearchType | async"
                [ngModelOptions]="{ standalone: true }"
                data-e2e-hook="bulk-download-article-number-search"
                [label]="
                    'BULK_GTIN_SEARCH.TYPE_SELECTOR.ARTICLE_NUMBER.TITLE'
                        | translate: { articleNumber: maxArticleNumbers }
                "
                (ngModelChange)="changeSearchType($event)"
            ></fcp-radiobutton>
        </div>

        <div class="fc-bulk-search-type-options-item">
            <fcp-radiobutton
                inputId="manufacturer-search-type-gtins"
                name="selectedSearchType"
                [value]="searchType.GTINS"
                [ngModel]="selectedSearchType | async"
                [ngModelOptions]="{ standalone: true }"
                data-e2e-hook="bulk-download-gtin-search"
                [label]="'BULK_GTIN_SEARCH.TYPE_SELECTOR.GTIN.TITLE' | translate: { gtin: maxGtins }"
                (ngModelChange)="changeSearchType($event)"
            ></fcp-radiobutton>
        </div>
    </div>

    <div class="fc-bulk-search-textarea-header">
        <div>{{ 'BULK_GTIN_SEARCH.PRODUCT_CODE_INPUT.TITLE' | translate }}</div>
    </div>

    <div class="fc-bulk-search-textarea">
        <textarea
            data-e2e-hook="bulk-search-input-area"
            #input
            placeholder="{{ 'BULK_GTIN_SEARCH.INPUT_PLACEHOLDER' | translate }}"
        ></textarea>
    </div>

    <div *ngIf="itemsLimitValidation | async as validation">
        <div *ngIf="validation.showNotification" class="fc-bulk-search-warning-messages">
            <fcp-alert *ngIf="isGtinsSearch | async" [type]="alertTypeEnum.Warning">
                {{ 'BULK_GTIN_SEARCH.EAN.LIMIT_REACHED.WARNING' | translate: { gtinLimit: maxGtins } }} "{{
                    validation.lastItem
                }}"
            </fcp-alert>
            <fcp-alert *ngIf="isArticleNumbersSearch | async" [type]="alertTypeEnum.Warning">
                {{
                    'BULK_GTIN_SEARCH.ARTICLE_NUMBERS_LIMIT_REACHED.WARNING'
                        | translate: { articleNumberLimit: maxArticleNumbers }
                }}
                "{{ validation.lastItem }}"
            </fcp-alert>
        </div>
    </div>

    <div *ngIf="itemsFormatValidation | async as validation">
        <div *ngIf="validation.showNotificationSomeInvalid" class="fc-bulk-search-warning-messages">
            <fcp-alert [type]="alertTypeEnum.Warning">
                {{
                    'BULK_GTIN_SEARCH.SOME_GTIN_INVALID'
                        | translate
                            : {
                                  invalidGtinsAmount: validation.invalidGtinsAmount,
                                  totalGtinsAmount: validation.totalGtinsAmount
                              }
                }}
                {{ validation.invalidGtinsSample }}
            </fcp-alert>
        </div>

        <div *ngIf="validation.showNotificationAllInvalid" class="fc-bulk-search-warning-messages">
            <fcp-alert [type]="alertTypeEnum.Error">{{ 'BULK_GTIN_SEARCH.ALL_GTINS_INVALID' | translate }}</fcp-alert>
        </div>
    </div>

    <div class="fc-bulk-search-download-header">
        <strong>{{ 'BULK_GTIN_SEARCH.DOWNLOAD_TYPE.TITLE' | translate }}</strong>
    </div>

    <div class="fc-bulk-search-download-controls">
        <div class="fc-bulk-search-download-options">
            <div class="fc-bulk-search-download-column">
                <div class="fc-bulk-search-download-toggle">
                    <fcp-toggle-switch
                        data-e2e-hook="bulk-download-option-images"
                        [ngModel]="selectedImageDownloadType"
                        [ngModelOptions]="{ standalone: true }"
                        (onChange)="onDownloadTypeSelected($event.checked, downloadEventType.DOWNLOAD_IMAGES)"
                    ></fcp-toggle-switch>
                    <span class="fc-bulk-search-download-toggle-label fcp-text-body-m">{{
                        'BULK_GTIN_SEARCH.DOWNLOAD_TYPE.IMAGES.TITLE' | translate
                    }}</span>
                </div>

                <div class="fc-bulk-search-download-multi-choice" *ngIf="selectedImageDownloadType">
                    <div
                        *ngFor="let resolutionOption of resolutionOptions"
                        class="fc-bulk-search-download-multi-choice-item"
                    >
                        <fcp-radiobutton
                            [inputId]="'manufacturer-resolution-' + resolutionOption.value"
                            name="selectedResolution"
                            [value]="resolutionOption.value"
                            [ngModel]="selectedResolution"
                            [ngModelOptions]="{ standalone: true }"
                            [disabled]="!selectedImageDownloadType"
                            [label]="resolutionOption.text | translate"
                            [attr.data-e2e-hook]="'bulk-download-select-resolution-' + resolutionOption.value"
                            (ngModelChange)="onResolutionSelected($event)"
                        ></fcp-radiobutton>
                    </div>
                </div>
            </div>

            <div class="fc-bulk-search-download-column" *ngIf="videoDownloadEnabled()">
                <div class="fc-bulk-search-download-toggle">
                    <fcp-toggle-switch
                        [e2e]="'bulk-download-option-videos'"
                        [ngModel]="selectedVideoDownloadType"
                        (onChange)="onDownloadTypeSelected($event.checked, downloadEventType.DOWNLOAD_VIDEOS)"
                    ></fcp-toggle-switch>
                    <span class="fc-bulk-search-download-toggle-label fcp-text-body-m">{{
                        'DOWNLOAD_CONTENT_MODAL.TOGGLE_VIDEOS' | translate
                    }}</span>
                </div>
            </div>

            <div class="fc-bulk-search-download-column">
                <div class="fc-bulk-search-download-toggle">
                    <fcp-toggle-switch
                        data-e2e-hook="bulk-download-option-csv"
                        [ngModel]="selectedCsvDownloadType"
                        (onChange)="onDownloadTypeSelected($event.checked, downloadEventType.DOWNLOAD_CSV)"
                    ></fcp-toggle-switch>
                    <span class="fc-bulk-search-download-toggle-label fcp-text-body-m">{{
                        'DOWNLOAD_CONTENT_MODAL.TOGGLE_DATA_ATTRIBUTES' | translate
                    }}</span>
                </div>

                <div class="fc-bulk-search-download-multi-choice" *ngIf="selectedCsvDownloadType">
                    <div
                        *ngFor="let csvLanguageOption of csvLanguageOptions"
                        class="fc-bulk-search-download-multi-choice-item"
                    >
                        <fcp-radiobutton
                            [inputId]="'manufacturer-csv-' + csvLanguageOption.value"
                            name="selectedCsvLanguage"
                            [value]="csvLanguageOption.value"
                            [ngModel]="selectedCsvLanguage"
                            [ngModelOptions]="{ standalone: true }"
                            [disabled]="!selectedCsvDownloadType"
                            [label]="csvLanguageOption.text | translate"
                            [additionalLabel]="csvLanguageOption.hint | translate"
                            [attr.data-e2e-hook]="'bulk-download-select-csv-language' + csvLanguageOption.value"
                            (ngModelChange)="onCsvLanguageSelected($event)"
                        ></fcp-radiobutton>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="fc-bulk-search-download-messages"
            *ngIf="
                (missingImagesInDownload | async) || (selectedCsvDownloadType && (missingProductDataInDownload | async))
            "
        >
            <div class="fc-bulk-search-download-messages-alert">
                <fcp-alert
                    *ngIf="missingImagesInDownload | async as missingImagesInDownload"
                    [type]="alertTypeEnum.Error"
                >
                    <span *ngIf="isGtinsSearch | async">
                        {{
                            'BULK_GTIN_SEARCH.GTINS.MISSING_IMAGE_RESULT'
                                | translate
                                    : {
                                          missingNumber: missingImagesInDownload.notFound,
                                          missingImagesNumber:
                                              missingImagesInDownload.notFoundImages + missingImagesInDownload.notFound,
                                          totalNumber: missingImagesInDownload.requested
                                      }
                        }}
                    </span>
                    <span *ngIf="isArticleNumbersSearch | async">
                        {{
                            'BULK_GTIN_SEARCH.ARTICLE_NUMBERS.MISSING_IMAGE_RESULT'
                                | translate
                                    : {
                                          missingNumber: missingImagesInDownload.notFound,
                                          missingImagesNumber:
                                              missingImagesInDownload.notFoundImages + missingImagesInDownload.notFound,
                                          totalNumber: missingImagesInDownload.requested
                                      }
                        }}
                    </span>
                </fcp-alert>
            </div>

            <div class="fc-bulk-search-download-messages-alert">
                <fcp-alert
                    *ngIf="selectedCsvDownloadType && missingProductDataInDownload | async"
                    [type]="alertTypeEnum.Error"
                >
                    {{ 'BULK_GTIN_SEARCH.CHECK_CSV' | translate }}
                </fcp-alert>
            </div>
        </div>

        <div class="fc-bulk-search-download-buttons">
            <button
                fcp-button
                color="prominent"
                [disabled]="!(isInputValid | async) || isDownloadDisabled"
                (click)="onClickDownload()"
                [attr.data-e2e-hook]="'bulk-download-button'"
            >
                <fcp-icon [icon]="['fal', 'download']"></fcp-icon>
                {{ 'ACTIONS.DOWNLOAD' | translate }}
            </button>
        </div>
    </div>
</div>
